import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesUpDown } from '@fortawesome/pro-regular-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { cn } from '~/helpers/utils';

type SelectWrapperProps = {
  className?: string;
  children?: React.ReactNode;
}

const SelectWrapper = ({ className, children }: SelectWrapperProps) => (
  <div className={cn('relative', className)}>
    {children}
    <FontAwesomeIcon icon={faAnglesUpDown as IconProp} className="pointer-events-none accent-color absolute text-sm top-1/2 -translate-y-1/2 right-3" />
  </div>
);

export default SelectWrapper;